<template>
  <div class="home">
    <div class="hero">
      <div class="container">
        <div class="row reversed-row-mobile">
          <div class="col-12 col-lg-7 col-xl-5">
            <h3>Bent u al klaar voor de stijgende zorgvraag?</h3>
            <h1>Lever meer zorg door slimmer te plannen</h1>
            <p>
              Zet uw behandelaars en middelen optimaal in met Roosterplatform om
              meer cliënten beter en sneller te behandelen.
            </p>

            <router-link
              to="/demo"
              class="button primary-button"
              tag="button"
            >
              Vraag demo aan
            </router-link>
          </div>
          <div class="col-12 col-lg-5 col-xl-7 hero-illusrtation">
            <svg
              id="blobSvg"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 500 500"
              width="100%"
              style="opacity: 1"
            >
              <defs>
                <linearGradient
                  id="gradient"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop
                    offset="0%"
                    style="stop-color: #2571ca"
                  />
                  <stop
                    offset="100%"
                    style="stop-color: #80c9f8"
                  />
                </linearGradient>
              </defs>

              <path
                id="blob"
                fill="url(#gradient)"
                style="opacity: 1"
              >
                <animate
                  attributeName="d"
                  dur="30000ms"
                  repeatCount="indefinite"
                  values="M395.5,320Q390,390,320,400Q250,410,172,408Q94,406,59,328Q24,250,70.5,183.5Q117,117,183.5,108Q250,99,335,89.5Q420,80,410.5,165Q401,250,395.5,320Z;M409.06419,322.5266Q395.0532,395.0532,322.5266,445.11739Q250,495.18159,163.51944,459.07135Q77.03888,422.96112,82.39949,336.48056Q87.7601,250,115.64271,196.76266Q143.52532,143.52532,196.76266,76.83657Q250,10.14783,323.24578,56.82813Q396.49156,103.50844,409.78338,176.75422Q423.07519,250,409.06419,322.5266Z;M449.66467,329.57458Q409.14917,409.14917,329.57458,407.97733Q250,406.80549,191.3735,387.02924Q132.74701,367.25299,77.06026,308.6265Q21.3735,250,49.05191,163.36516Q76.73032,76.73032,163.36516,85.537Q250,94.34367,322.00775,100.16408Q394.01551,105.98449,442.09784,177.99225Q490.18018,250,449.66467,329.57458Z;M423.42552,332.41134Q414.82268,414.82268,332.41134,424.30554Q250,433.78841,170.96572,420.92848Q91.93144,408.06856,46.07152,329.03428Q0.21159,250,66.88003,191.77423Q133.54846,133.54846,191.77423,102.82861Q250,72.10876,305.00592,106.04846Q360.01185,139.98815,396.0201,194.99408Q432.02836,250,423.42552,332.41134Z;M405.0078,325.44624Q400.89248,400.89248,325.44624,434.97549Q250,469.0585,165.42535,444.1039Q80.8507,419.1493,84.75627,334.57465Q88.66184,250,94.44262,175.1117Q100.2234,100.2234,175.1117,82.29749Q250,64.37159,306.73538,100.45042Q363.47075,136.52925,386.29693,193.26462Q409.12312,250,405.0078,325.44624Z;M395.5,320Q390,390,320,400Q250,410,172,408Q94,406,59,328Q24,250,70.5,183.5Q117,117,183.5,108Q250,99,335,89.5Q420,80,410.5,165Q401,250,395.5,320Z"
                />
              </path>
            </svg>
            <img
              src="../assets/img/hero-illusrtation.png"
              alt=""
            >
          </div>
        </div>
      </div>

      <b-carousel
        id="carousel-2"
        class="clients-carousel"
        :interval="3000"
      >
        <b-carousel-slide>
          <template v-slot:img>
            <img
              src="../assets/img/clients/tanteLouise.png"
              alt=""
            >
            <img
              src="../assets/img/clients/alliade.png"
              alt=""
            >
            <img
              src="../assets/img/clients/azora.png"
              alt=""
            >
            <img
              src="../assets/img/clients/carinova.png"
              alt=""
            >
            <img
              src="../assets/img/clients/charim.png"
              alt=""
            >
            <img
              src="../assets/img/clients/cordaan.png"
              alt=""
            >
          </template>
        </b-carousel-slide>
        <b-carousel-slide>
          <template v-slot:img>
            <img
              src="../assets/img/clients/groenhuysen.png"
              alt=""
            >
            <img
              src="../assets/img/clients/laurens.png"
              alt=""
            >
            <img
              src="../assets/img/clients/noorderbreedte.png"
              alt=""
            >
            <img
              src="../assets/img/clients/pzc.png"
              alt=""
            >
            <img
              src="../assets/img/clients/sensire.png"
              alt=""
            >
          </template>
        </b-carousel-slide>
        <b-carousel-slide>
          <template v-slot:img>
            <img
              src="../assets/img/clients/topaz.png"
              alt=""
            >
            <img
              src="../assets/img/clients/visio.png"
              alt=""
            >
            <img
              src="../assets/img/clients/vivium.png"
              alt=""
            >
            <img
              src="../assets/img/clients/ijselheem.png"
              alt=""
            >
            <img
              src="../assets/img/clients/zinzia.png"
              alt=""
            >
            <img
              src="../assets/img/clients/zonnehuisgroep.png"
              alt=""
            >
          </template>
        </b-carousel-slide>
      </b-carousel>
    </div>
    <div class="section primary">
      <div class="container">
        <div class="section-title">
          <span>Welke problemen lossen we voor u op?</span>
          <h2>Wat u met Roosterplatform bereikt</h2>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="problem-block">
              <img
                src="../assets/img/usp-1.svg"
                alt="Juiste match van uw vraag en aanbod"
              >
              <div class="sub-title">
                Juiste match van uw vraag en aanbod
              </div>
              <p>
                Uw personeelstekort groeit en de zorgvraag stijgt.
                Roosterplatform helpt om dit op te vangen door uw behandelaars
                en middelen optimaal in te zetten.
              </p>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="problem-block">
              <img
                src="../assets/img/usp-2.svg"
                alt="Meer zorg leveren met dezelfde behandelaars"
              >
              <div class="sub-title">
                Meer zorg leveren met dezelfde behandelaars
              </div>
              <p>
                Er zijn 22 duizend behandelplekken te weinig in Nederland.
                Roosterplatform optimaliseert uw behandelagenda waardoor uw
                behandelaars meer cliënten kunnen helpen.
              </p>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="problem-block">
              <img
                src="../assets/img/usp-3.svg"
                alt="plexe zorg beheersbaar hou"
              >
              <div class="sub-title">
                Complexe zorg beheersbaar houden
              </div>
              <p>
                De toenemende multi-morbiditeit maakt de planning zo ingewikkeld
                dat uw planners die niet meer uit hun hoofd kunnen doen.
                Roosterplatform beheert alle variabelen en gebruikt ze als basis
                voor een optimale planning.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section grey-light">
      <div class="container">
        <div class="section-title">
          <span>Zo doen we het</span>
          <h2>Hoe we uw organisatie helpen</h2>
        </div>
        <div class="row feature-row">
          <div class="col">
            <img
              src="../assets/img/features/main-feature-1.png"
              alt=""
            >
          </div>
          <div class="col">
            <h3>Sturen in plaats van reageren</h3>
            <p>
              Uw organisatie legt alle roosterregels digitaal vast in
              Roosterplatform en daarmee is uw roosterstrategie beschermd,
              inzichtelijk en beheersbaar. Hiermee stuurt u op optimaal inzetten
              van behandelaars en middelen en wordt uw resultaat voorspelbaar.
              Want met Roosterplatform voorkomt u onverwachte knelpunten en
              verliest u geen tijd meer aan reageren op incidenten.
            </p>
            <ul class="benifits-list">
              <li>Jouw voordelen</li>
              <li>Roosterstrategie is digitaal vastgelegd en beschermd</li>
              <li>Behandelaars en middelen optimaal ingezet</li>
              <li>
                Resultaat voorspelbaar en geen onverwachte knelpunten meer
              </li>
            </ul>
          </div>
        </div>
        <div class="row feature-row">
          <div class="col">
            <img
              src="../assets/img/features/main-feature-2.png"
              alt=""
            >
          </div>
          <div class="col">
            <h3>Volledig geautomatiseerd plannen</h3>
            <p>
              Met de vastgelegde roosterstrategie zoals rusttijden tussen
              behandelingen plant Roosterplatform volledig geautomatiseerd uw
              optimale behandelagenda in slechts een paar minuten. En u kunt de
              strategie voor cliënten eenvoudig aanpassen – bijvoorbeeld meer of
              minder behandelingen op een dag – en daarna Roosterplatform snel
              een aangepaste agenda laten maken. Daardoor houdt u zich alleen
              nog maar bezig met wat uitzonderingen inpassen.
            </p>
            <ul class="benifits-list">
              <li>Jouw voordelen</li>
              <li>In slechts enkele minuten een optimale behandelagenda</li>
              <li>Wijzigingen zijn eenvoudig en snel door te voeren</li>
              <li>Alleen nog maar uitzonderingen inpassen en verfijnen</li>
            </ul>
          </div>
        </div>
        <div class="row feature-row">
          <div class="col">
            <img
              src="../assets/img/features/main-feature-3.png"
              alt=""
            >
          </div>
          <div class="col">
            <h3>Meer cliënten beter en sneller behandelen</h3>
            <p>
              Door Roosterplatform helpen uw behandelaars meer cliënten want er
              zijn geen onnodige gaten meer in de behandelagenda en elk
              beschikbaar behandelmoment wordt benut. Daardoor voert u de
              behandelingen volgens plan uit en dat is beter voor uw cliënten
              omdat ze sneller herstellen. En zelfs lastig te plannen
              groepsbehandelingen regelt u eenvoudig met Roosterplatform
              waardoor u nog meer cliënten kunt behandelen.
            </p>
            <ul class="benifits-list">
              <li>Jouw voordelen</li>
              <li>
                Optimale behandelagenda en betere behandelingen door behandelen
                volgens plan
              </li>
              <li>
                Cliënten herstellen sneller waardoor ze eerder naar huis gaan en
                u meer kunt behandelen
              </li>
              <li>Groepsbehandelingen zijn eenvoudig te regelen</li>
            </ul>
          </div>
        </div>
        <div class="row feature-row">
          <div class="col">
            <img
              src="../assets/img/features/main-feature-4.png"
              alt=""
            >
          </div>
          <div class="col">
            <h3>Samenwerken met andere systemen</h3>
            <p>
              Koppel Roosterplatform met andere systemen en haal zo nog meer uit
              uw digitalisering. Voorkom zo tijdsverspilling door dubbele
              invoer. En geef bijvoorbeeld mantelzorgers of de eigen
              fysiotherapeut van een cliënt via de Caren-app toegang tot de
              behandelagenda zodat zij het natraject optimaal kunnen verzorgen.
            </p>
            <ul class="benifits-list">
              <li>Jouw voordelen</li>
              <li>Dubbele invoer voorkomen</li>
              <li>
                Mantelzorgers en andere professionals helpen mee aan optimale
                behandeling
              </li>
              <li>Integraal behandelen</li>
            </ul>
          </div>
        </div>
        <div class="other-usps">
          <h3 class="text-center">
            Nog meer redenen waarom klanten voor Roosterplatform kiezen
          </h3>
          <div class="row">
            <div class="col-4">
              <div class="quality-mark">
                <img
                  src="../assets/img/usp/nen-iso.png"
                  alt=""
                >
              </div>
            </div>
            <div class="col-6 offset-md-1">
              <div class="row">
                <div class="col-6">
                  <ul class="usps-list">
                    <li>
                      <i class="material-icons-outlined">done_all</i>
                      <p><b>ISO</b> en <b>NEN</b> certificering</p>
                    </li>
                    <li>
                      <i class="material-icons-outlined">view_week</i>
                      <p><b>24/7</b> bereikbaar</p>
                    </li>
                    <li>
                      <i class="material-icons-outlined">supervised_user_circle</i>
                      <p><b>Multidisciplinair</b> team</p>
                    </li>
                  </ul>
                </div>
                <div class="col-6">
                  <ul class="usps-list">
                    <li>
                      <i class="material-icons-outlined">laptop_chromebook</i>
                      <p>Web, Android and iOS <b>app</b></p>
                    </li>
                    <li>
                      <i class="material-icons-outlined">all_inclusive</i>
                      <p><b>+15 jaar</b> ervaring</p>
                    </li>
                    <li>
                      <i class="material-icons-outlined">bolt</i>
                      <p><b>Snelle</b> implementatie</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section primary">
      <app-clients-carousel />
    </div>
    <div class="section grey-light extra-padding-bottom">
      <div class="container">
        <div class="section-title">
          <span>Blog en nieuws</span>
          <h2>Laatste blogs en nieuws</h2>
        </div>
        <div class="blog-summary">
          <div class="row">
            <div class="col-12 col-lg-4 col-xl-4">
              <div class="image">
                <img
                  src="../assets/img/blog-images/anders-denken.png"
                  alt=""
                >
              </div>
              <div class="blog-title">
                <h3>Anders denken, Anders doen!</h3>
              </div>
              <div class="blog-short-desc">
                <p>
                  Anders denken, Anders doen! Geregeld wordt aan mij gevraagd
                  wat eigenlijk het verschil is tussen het plannen met een
                  digitaal planbord en plannen met Roosterplatform. Als ik deze
                  vraag krijg...
                </p>
                <router-link to="/anders-denken-anders-doen">
                  Lees meer
                </router-link>
              </div>
            </div>
            <div class="col-12 col-lg-4 col-xl-4">
              <div class="image">
                <img
                  src="../assets/img/blog-images/geld.png"
                  alt=""
                >
              </div>
              <div class="blog-title">
                <h3>Een efficiënte planning levert geld op!</h3>
              </div>
              <div class="blog-short-desc">
                <p>
                  Vraag eens aan een manager uit de logistieke branche wat het
                  oplevert als hij iets efficiënter zou omgaan met zijn
                  resources. Zijn antwoord zal zijn, ‘het optimaliseren van
                  processen is
                </p>
                <router-link to="/een-efficiënte-planning-levert-geld-op">
                  Lees meer
                </router-link>
              </div>
            </div>
            <div class="col-12 col-lg-4 col-xl-4">
              <div class="image">
                <img
                  src="../assets/img/blog-images/msr-grz.png"
                  alt=""
                >
              </div>
              <div class="blog-title">
                <h3>De MSR en de GRZ zijn gewoon gelijk!</h3>
              </div>
              <div class="blog-short-desc">
                <p>
                  Roosterplatform heeft bij meerdere Medisch Specialistische
                  Revalidatiecentra (MSR) de planprocessen geanalyseerd. Bij
                  Merem heeft Roosterplatform daadwerkelijk kunnen schaduw
                  draaien en daarmee onderzocht of de software geschikt is voor
                  de MSR.
                </p>
                <router-link to="/de-MSR-en-de-GRZ-zijn-gewoon-gelijk">
                  Lees meer
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center">
          <router-link
            to="/blog"
            class="button secondary-button"
            tag="button"
          >
            Meer blogs en nieuws
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Home",

  mounted() { },
  methods: {},
  metaInfo() {
    return {
      title: "Roosterplatform - Homepage",
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";

.hero {
  padding: 150px 0 100px;

  p {
    font-size: $big;
  }

  h3 {
    opacity: 0.3;
    font-weight: 700;
    margin-top: 100px;
  }
}

.blog-summary {
  margin-bottom: 50px;

  .image {
    img {
      border-radius: 8px;
      margin-block: 16px;
    }
  }

  .blog-short-desc {
    p {
      display: -webkit-box;
      max-width: 100%;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}

.hero-illusrtation {
  &:before {
    content: "";
    position: absolute;
    width: 700px;
    height: 700px;
    border-radius: 50%;
    background: $primary;
    opacity: 0.2;
    z-index: 0;
    right: 10%;
    top: -10%;
    display: none;
  }

  svg {
    position: absolute;
    top: -100px;
    left: 0;
    width: 600px;
  }

  img {
    position: relative;
  }
}

.clients-carousel {
  max-width: 1000px;
  text-align: center;
  margin: 100px auto 0;

  img {
    width: 16.6666%;
    opacity: 0.7;
    transition: $transition;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translateZ(0) scale(0.7, 0.7);

    &:hover {
      opacity: 1;
    }
  }
}

.feature-row {
  margin: 50px 0 100px;

  &:nth-child(odd) {
    flex-direction: row-reverse;
  }
}

.benifits-list {
  margin: 30px 0 0;

  li {
    list-style-type: none;
    opacity: 0.7;
    font-size: $small;
    margin-bottom: 10px;

    &:first-child {
      text-transform: uppercase;
      opacity: 0.3;
      font-weight: 700;
      margin-left: -20px;
      margin: 0 0 10px -20px;

      &:before {
        display: none;
      }
    }

    &:before {
      content: "add_circle_outline";
      font-family: "Material Icons Outlined";
      color: $secondary;
      top: 3px;
      position: relative;
      margin: 0 5px 0 -10px;
    }
  }
}

.quality-mark {
  text-align: right;
  margin: 40px 0 0;
}

.usps-list {
  padding: 0;
  margin: 40px 0 0;

  li {
    list-style-type: none;
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    i {
      height: 40px;
      width: 40px;
      background: $accent;
      text-align: center;
      line-height: 40px;
      color: $primary;
      border-radius: $border-radius;
    }

    p {
      margin: 0 0 0 30px;
    }
  }
}

.latest-news-iframe {
  width: 100%;
  height: 500px;
  border: none;
}

.problem-block {
  position: relative;

  img {
    background: $white;
    padding: 20px;
    border-radius: $border-radius;
  }
}

@media (max-width: 1199px) {
  .hero {
    .hero-illusrtation svg {
      width: 300px;
    }

    h3 {
      margin: 0;
    }
  }
}

@media (max-width: 991px) {
  .hero {
    padding: 50px 0;

    .hero-illusrtation svg {
      width: 500px;
      top: auto;
      bottom: 0;
    }
  }
}

@media (max-width: 767px) {
  .hero {
    .hero-illusrtation {
      margin-top: 50px;

      svg {
        width: 50%;
        top: auto;
        bottom: 0;
      }
    }
  }

  .benifits-list {
    margin: 20px 0 0 -20px;
  }

  .problem-block {
    padding-left: 80px;

    img {
      position: absolute;
      padding: 10px;
      left: 0;
      top: 10px;
      max-width: 60px;
    }
  }

  .feature-row {
    display: block;
    margin: 0 0 100px;

    .col {
      padding: 0;

      img {
        margin-bottom: 20px;
      }

      p {
        margin-bottom: 0px;
      }
    }
  }

  .other-usps {
    .quality-mark {
      text-align: center;
      margin-bottom: 30px;
    }

    ul {
      margin: 0 0 0 30px;

      li {
        p {
          margin: 0 0 0 20px;
        }
      }
    }

    .row {
      display: block;

      div[class*="col"] {
        display: block;
        width: 100%;
        max-width: 100%;
      }
    }
  }

  .latest-news-iframe {
    height: 1310px;
  }
}
</style>
